// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2DeA-","footer":"ModalError_footer__3Oy9H"};